import { Button, ButtonVariant } from '@dreryk/react-components';

import { translationKeys } from '../translations';

type SummaryButtonProps = {
   isLoading: boolean;
   disabled: boolean;
   onSummarize: VoidFunction;
};

export const SummaryButton = (props: SummaryButtonProps): JSX.Element => {
   const label = props.isLoading ? translationKeys.panel.summaryButtonLoading : translationKeys.panel.summaryButton;

   return (
      <Button
         testId={'summaryButton'}
         label={label}
         onClick={props.onSummarize}
         disabled={props.disabled || props.isLoading}
         variant={ButtonVariant.PRIMARY}
         blockingOperation={props.isLoading}
         fullLength
      />
   );
};
